import React from 'react';
import { Info, Help } from './Components';

export const AuthenticationInfo = ({ config }) => (
    <Info
        title="Authentication"
        text={`Please provide the ${config.label} credentials.`}
    />
);

export const HelpLink = ({ config }) => (
    <Help
        title={`Need help with the ${config.label} integration`}
        link={`${config.label} Setup Guide`}
        brand={config.guide_url}
    />
);
